import React, { useState } from 'react';
import Logo from '../Logo';
import Box from '@mui/material/Box';
import { useTheme } from '../../contexts/ThemeContext';

export default function EnhancedSpinningLogo({ width = "37px", height = "47px" }) {
  const { theme } = useTheme();
  const [clicked, setClicked] = useState(false);

  // Animation options
  const animations = {
    pulse: 'App-logo-pulse 2s ease-in-out infinite',
    spin: 'App-logo-spin 2s linear infinite',
    bounce: 'App-logo-bounce 1s ease infinite',
    shake: 'App-logo-shake 0.5s ease infinite',
    flip: 'App-logo-flip 2s linear infinite',
  };

  // Current animation state
  const [currentAnimation, setCurrentAnimation] = useState('pulse');

  // Handle animation change on click
  const handleClick = () => {
    setClicked(true);
    // Cycle through animations
    const animationKeys = Object.keys(animations);
    const currentIndex = animationKeys.indexOf(currentAnimation);
    const nextIndex = (currentIndex + 1) % animationKeys.length;
    setCurrentAnimation(animationKeys[nextIndex]);

    // Reset clicked state after animation
    setTimeout(() => setClicked(false), 100);
  };

  // Animation styles
  const logoStyles = {
    animation: animations[currentAnimation],
    display: 'inline-block',
    cursor: 'pointer',
    transition: 'transform 0.3s, filter 0.3s',
    transform: clicked ? 'scale(0.9)' : 'scale(1)',
    filter: 'none',
    animationPlayState: 'running',
  };

  return (
    <Box
      sx={logoStyles}
      onClick={handleClick}
    >
      <Logo
        fill={theme.color.primary}
        width={width}
        height={height}
        background={theme.background.primary}
      />
    </Box>
  );
}